import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { DescricaoPrioridade, PrioridadeEnum } from 'src/app/enum/prioridade.enum';
import { DescricaoStatusTicket, StatusTicketEnum } from 'src/app/enum/statusTicket.enum';
import { DescricaoTipoTicket, TipoTicketEnum } from 'src/app/enum/tipoTicket.enum';
import { ClientService } from 'src/app/service/client.service';
import { SegmentoService } from 'src/app/service/segmento.service';
import { TicketService } from 'src/app/service/ticket.service';
import { isFiltroIdNumerico } from 'src/app/util/consulta/wow-consulta.util';
import { Client } from '../client/client';
import { Segmento } from '../segmento/segmento';
import { Usuario } from '../usuario/usuario';
import { Ticket } from './ticket';

@Component({
  selector: 'app-ticket-consulta',
  templateUrl: './ticket-consulta.component.html',
  styleUrls: [
    './ticket.component.scss',
    '../../util/conta-financeira/conta-financeira-consulta.scss',
  ],
})
export class TicketConsultaComponent implements OnInit {

  tickets: Ticket[] = [];
  segmentos: Segmento[] = [];
  parceiros: Client[] = [];
  atribuicoes: Usuario[] = [];
  prioridades = Object.values(PrioridadeEnum);
  categorias = Object.values(TipoTicketEnum);
  statusOpcoes = Object.values(StatusTicketEnum);

  ordemColunasTabela = [
    'id', 'segmento', 'responsavel', 'assunto', 'categoria', 'status',
    'dataCriacao', 'dataPrevisaoEntrega', 'editar',
  ];
  totalElementos = 0;
  pagina = 0;
  tamanho = 5;
  pageSizeOptions: number[] = [5, 10, 15, 100];
  consultaRealizada = false;

  filtroId = '';
  filtroSegmento: string | null = null;
  filtroParceiroId: number | null = null;
  filtroPrioridade: PrioridadeEnum | null = null;
  filtroCategoria: TipoTicketEnum | null = null;
  filtroAtribuidoId: number | null = null;
  filtroStatus: StatusTicketEnum | null = null;

  constructor(
    private ticketService: TicketService,
    private segmentoService: SegmentoService,
    private clientService: ClientService,
    private snackBar: MatSnackBar,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.segmentoService.listarAtivos().subscribe(lista => this.segmentos = lista ?? []);
    this.clientService.listarCliente().subscribe(lista => this.parceiros = lista ?? []);
    this.ticketService.buscarUsuariosAtribuicao().subscribe(lista => this.atribuicoes = lista ?? []);
  }

  consultar(resetPagina = true) {
    if (resetPagina) {
      this.pagina = 0;
    }

    const idFiltro = isFiltroIdNumerico('ID', this.filtroId);
    if (this.filtroId?.trim() && idFiltro == null) {
      this.snackBar.open('Informe um ID numérico válido.', 'ERRO', { duration: 2500 });
      return;
    }

    this.ticketService.consultar({
      id: idFiltro,
      segmento: this.filtroSegmento,
      parceiroId: this.filtroParceiroId,
      prioridade: this.filtroPrioridade,
      tipo: this.filtroCategoria,
      atribuidoId: this.filtroAtribuidoId,
      status: this.filtroStatus,
    }, this.pagina, this.tamanho).subscribe({
      next: (response) => {
        this.tickets = response.content ?? [];
        this.totalElementos = response.totalElements ?? 0;
        this.consultaRealizada = true;
      },
      error: () => this.snackBar.open('Erro ao consultar tickets.', 'ERRO', { duration: 2500 }),
    });
  }

  paginar(event: PageEvent) {
    if (!this.consultaRealizada) {
      return;
    }
    this.pagina = event.pageIndex;
    this.tamanho = event.pageSize;
    this.consultar(false);
  }

  novo() {
    this.router.navigate(['/ticket/form']);
  }

  editar(id: number) {
    this.router.navigate(['/ticket/form', id]);
  }

  labelSegmento(codigo?: string): string {
    if (!codigo) {
      return '';
    }
    return this.segmentos.find(s => s.codigo === codigo)?.nome ?? codigo;
  }

  getDescricaoTipoTicket(tipo: TipoTicketEnum): string {
    return DescricaoTipoTicket.get(tipo) || '';
  }

  getDescricaoStatusTicket(status: StatusTicketEnum): string {
    return DescricaoStatusTicket.get(status) || '';
  }

  getDescricaoPrioridade(prioridade: PrioridadeEnum): string {
    return DescricaoPrioridade.get(prioridade) || '';
  }

  nomeResponsavel(ticket: Ticket): string {
    const dev = ticket.responsavelDesenvolvimento as any;
    const sup = ticket.responsavelSuporte as any;
    return dev?.name ?? sup?.name ?? '—';
  }
}
